import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getId, isset } from '@cawita/core-front';
import { Notification, NotificationType } from '../../../../../frontend-shared/src/lib/models';
import { getProfileToViewAs } from '../../utils';
import { LoggedProfileStore } from '../profile';

@Injectable({ providedIn: 'root' })
export class NotificationHandlerService {
    private _handlers: Partial<Record<NotificationType, (notif: Notification) => void>> = {
        [NotificationType.PartnerMsg]: this.handleUpConvNotification.bind(this),
        [NotificationType.PartnerDocument]: this.handleCustomerSpaceNotification.bind(this),
        [NotificationType.CreateEvent]: this.handleEventNotification.bind(this),
        [NotificationType.UpdateEvent]: this.handleEventNotification.bind(this),
        [NotificationType.DeleteEvent]: this.handleEventNotification.bind(this),
        [NotificationType.CreateReservation]: this.handleEventNotification.bind(this),
        [NotificationType.DeleteReservation]: this.handleEventNotification.bind(this),
        [NotificationType.Flash]: this.handleAffinityNotification.bind(this),
        [NotificationType.Katch]: this.handleAffinityNotification.bind(this),
        [NotificationType.Prestation]: this.handleCustomerSpaceNotification.bind(this),
        [NotificationType.HostComment]: this.handleCommentNotification.bind(this),
    };

    constructor(
        private profile: LoggedProfileStore,
        private router: Router
    ) { }

    public canHandle(notif: Notification) {
        return isset(notif?.type) && isset(this._handlers[notif?.type]);
    }

    public async handle(notif: Notification) {
        if (!this.canHandle(notif)) return;
        this._handlers[notif?.type](notif);
    }

    private handleAffinityNotification(notif: Notification) {
        if (!isset(notif?.content?.affinityId)) return;
        const { profile } = this.profile.getValue();
        const otherProfile = getProfileToViewAs(notif?.content, profile);
        this.router.navigate(['/profile', getId(otherProfile)]);
    }

    private handleEventNotification(notif: Notification) {
        if (notif?.type === NotificationType.DeleteEvent) return;
        if (!isset(notif?.content?.event)) return;
        this.router.navigate(['/event', getId(notif?.content?.event)]);
    }

    private handleCommentNotification(notif: Notification) {
        if (!isset(notif?.content?.event)) return;
        this.router.navigate(['/event', getId(notif?.content?.event)]);
    }

    private handleCustomerSpaceNotification(notif: Notification) {
        this.router.navigate(['/customer-space']);
    }

    private handleUpConvNotification(notif: Notification) {
        this.router.navigate(['/conversation']);
    }
}